export default {
  methods: {
    emitOnAction() {
      this.$emit('action');
    },
  },
};
